enum Pages {
  DEVICES = '1',
  RESOURCES = '2',
  PLAYER_SETTINGS = '3'
}

export default Pages;
